<template>

<com-screen id="app" :loading="loading">

	<app-accept />
	<app-contract />

	<router-view :key="$keyPath" />

	<template v-slot:menu>

		<com-menu>
		
			<com-foot v-if="!window.is.desktop" />

		</com-menu>

	</template>

	<com-foot v-if="window.is.desktop" />

</com-screen>

</template>

<script>

import onScan from 'onscan.js'

import comScreen from './screen/Wrapper'
import comFoot from './screen/Foot'
import comMenu from './screen/manager/Menu'

export default {

	name: 'App',

	components: {
		'com-screen': comScreen,
		'com-menu': comMenu,
		'com-foot': comFoot
	},

	created: async function() {

		onScan.attachTo(document)

		document.addEventListener('scan', this.onScanDetected.bind(this))

	},
	
	beforeDestroy: function() {

		onScan.detachFrom(document)

		document.removeEventListener('scan', this.onScanDetected.bind(this))

	},

	computed: {

		loading: function() {

			return !this.$store.getters['initiated'] || this.$store.getters['context/checking']

		}
		
	},

	methods: {

		onScanDetected: function(e) {

			var parts = this.$route.name.split('.')
			
			if (parts[0] === 'Membership') {

				this.$router.push({
					name: 'Membership.Checkins.Scan',
					query: {
						code: e.detail.scanCode,
						redirect: this.$route.path
					}
				})

			}

		}

	}

}

</script>

<style>

body {
	overflow: hidden;
}

</style>
